<template>
  <footer class="container-fluid fixed-bottom footer-area fixed bottom footer--light bg-gradient-primary" >

  <div  style="border:1px solid" class="bg-success text-white">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="copyright-text small">
            Luxury Lease Partners LLC

          </div>
        </div>
        <div class="col-md-6">
          <div class="text-right">
           <span >Terms of Use | Privacy Policy | Advertise | Sitemap  </span>

          </div>
        </div>
        <!-- <div class="col-md-3">
          <div class="text-right small">
            Powered by MyCompany Techologies LLC

          </div>
        </div> -->
      </div>
    </div>
  </div>
</footer>
</template>
<script>

export default {
  data () {
    return {

    }
  },
  components: {

  }
}
</script>
<style scoped>

</style>
